import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { configureAnchors } from "react-scrollable-anchor";

import { Accordion, MediaContainer } from "../components";
import { NAVIGATION_HEIGHT } from "../layouts/Navigation";
import { HEADER_HEIGHT } from "../layouts/Header";
import { SUMMARY_BAR_HEIGHT, SUMMARY_BAR_BORDER_WIDTH } from "../components/SummaryBar";
import buildAssetUrl from "../utils/buildAssetUrl";
import normalizeHotspots from "../utils/normalizeHotspots";

configureAnchors({
    offset: -(NAVIGATION_HEIGHT + HEADER_HEIGHT + SUMMARY_BAR_HEIGHT - SUMMARY_BAR_BORDER_WIDTH),
    scrollDuration: 800,
});

const styles = {};

const EMobilityHotspot = ({ classes, hotspots, image }) => {
    const [activePanel, setActivePanel] = useState();

    const normalizedHotspots = normalizeHotspots(image, hotspots);
    const { url: imageUrl } = buildAssetUrl(image);

    return (
        <Grid container spacing={24} className="content-container">
            <Grid item xs={12} sm={8} className="content-item">
                <MediaContainer
                    image={imageUrl}
                    hotspots={normalizedHotspots}
                    activePanel={activePanel}
                    onHotspotClick={setActivePanel}
                />
            </Grid>

            <Grid item xs={12} sm={4} className="content-item">
                <Accordion panels={normalizedHotspots} activePanel={activePanel} onActivePanelChange={setActivePanel} />
            </Grid>
        </Grid>
    );
};

export default withStyles(styles)(EMobilityHotspot);



// WEBPACK FOOTER //
// ./src/emobility/EMobilityHotspot.js